var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flexX" },
    [
      _vm.isGridView
        ? _c("GridCard", {
            attrs: { newList: _vm.stories },
            on: {
              deleteStory: function($event) {
                return _vm.deleteStory($event)
              },
              downloadStory: function($event) {
                return _vm.downloadStory($event)
              },
              editStoryInfo: function($event) {
                return _vm.editStoryInfo($event)
              },
              copyStory: function($event) {
                return _vm.copyStory($event)
              },
              shareStory: function($event) {
                return _vm.shareStory($event)
              },
              copyLink: function($event) {
                return _vm.copyLink($event)
              },
              viewStoryDetail: function($event) {
                return _vm.viewStoryDetail($event)
              },
              addToStarred: function($event) {
                return _vm.addToStarred($event)
              },
              removeFromStarred: function($event) {
                return _vm.removeFromStarred($event)
              },
              sort: _vm.setSortOrderListView
            }
          })
        : _c("Table", {
            attrs: { data: _vm.stories, config: _vm.config },
            on: {
              deleteStory: function($event) {
                return _vm.deleteStory($event)
              },
              downloadStory: function($event) {
                return _vm.downloadStory($event)
              },
              editStoryInfo: function($event) {
                return _vm.editStoryInfo($event)
              },
              copyStory: function($event) {
                return _vm.copyStory($event)
              },
              shareStory: function($event) {
                return _vm.shareStory($event)
              },
              copyLink: function($event) {
                return _vm.copyLink($event)
              },
              viewStoryDetail: function($event) {
                return _vm.viewStoryDetail($event)
              },
              addToStarred: function($event) {
                return _vm.addToStarred($event)
              },
              removeFromStarred: function($event) {
                return _vm.removeFromStarred($event)
              },
              iconClicked: _vm.setSortOrderListView
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03f36ae1", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f36ae1","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-list-view/parentListGridCard.vue
// module id = null
// module chunks = 